import { render, staticRenderFns } from "./VehicleConflictModal.vue?vue&type=template&id=87f66fae&scoped=true"
import script from "./VehicleConflictModal.vue?vue&type=script&lang=js"
export * from "./VehicleConflictModal.vue?vue&type=script&lang=js"
import style0 from "./VehicleConflictModal.vue?vue&type=style&index=0&id=87f66fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f66fae",
  null
  
)

export default component.exports